import { Button, Text } from '@/ui'
import { TextColors, TypographyStyles } from '@/styles'
import {
  EMPTY_TAB_ACTION,
  EMPTY_TAB_TITLE,
  FIRST_RUN_BODY,
  FIRST_RUN_TITLE,
  NO_RESULTS_TITLE,
} from '../../lib/messageTabs'

type MessagesEmptyVariant = 'filtered' | 'noResults' | 'firstRun'

const TITLE_BY_VARIANT: Record<MessagesEmptyVariant, string> = {
  filtered: EMPTY_TAB_TITLE,
  noResults: NO_RESULTS_TITLE,
  firstRun: FIRST_RUN_TITLE,
}

interface MessagesEmptyStateProps {
  variant: MessagesEmptyVariant
  onSeeAll: () => void
}

export const MessagesEmptyState = ({
  variant,
  onSeeAll,
}: MessagesEmptyStateProps) => {
  const title = TITLE_BY_VARIANT[variant]

  return (
    <div className="flex flex-col items-center gap-2 px-6 py-10 text-center">
      <Text
        variant={TypographyStyles.LABEL_MD}
        className="font-semibold text-neutral-800"
      >
        {title}
      </Text>
      {variant === 'firstRun' ? (
        <Text variant={TypographyStyles.BODY_SM} color={TextColors.MUTED}>
          {FIRST_RUN_BODY}
        </Text>
      ) : (
        <Button variant="secondary" size="sm" onClick={onSeeAll}>
          {EMPTY_TAB_ACTION}
        </Button>
      )}
    </div>
  )
}
